import React, {Component} from 'react';
import Pagination from 'react-js-pagination';

class Paginate extends Component {
  render() {
    return (
      <div>
        <Pagination
          activePage={parseInt(this.props.currentPage)}
          itemsCountPerPage={10}
          totalItemsCount={this.props.totalItemCount}
          pageRangeDisplayed={this.props.pageRangeDisplayed ? this.props.pageRangeDisplayed : 5}
          innerClass="paging"
          linkClass="paging-link"
          activeLinkClass="active"
          prevPageText={<img alt="prev" src="/image/button/btn_paging_prev.gif" />}
          firstPageText={<img alt="first" src="/image/button/btn_paging_first.gif" />}
          nextPageText={<img alt="next" src="/image/button/btn_paging_next.gif" />}
          lastPageText={<img alt="end" src="/image/button/btn_paging_end.gif" />}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

export default Paginate;
